/* eslint-disable @typescript-eslint/member-ordering */

import { computed, inject, Injectable, signal, Signal, WritableSignal } from '@angular/core';
import { EnvironmentService } from '../environment';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsService {
  private readonly environmentService: EnvironmentService = inject(EnvironmentService);

  public blockingCustomersEnabled: Signal<boolean> = computed(() => this._blockingCustomersEnabled());
  private readonly _blockingCustomersEnabled: WritableSignal<boolean> = signal(true);

  public forceNativeAppUpdateEnabled: Signal<boolean> = computed(() => this._forceNativeAppUpdateEnabled());
  private readonly _forceNativeAppUpdateEnabled: WritableSignal<boolean> = signal(false);

  public publicAppEnabled: Signal<boolean> = computed(() => this._publicAppEnabled());
  private readonly _publicAppEnabled: WritableSignal<boolean> = signal(false);

  // DCP App Config
  public newAppConfigEnabled: Signal<boolean> = computed(() => this._newAppConfigEnabled());
  private readonly _newAppConfigEnabled: WritableSignal<boolean> = signal(false);

  public orderVouchersEnabled: Signal<boolean> = computed(() => this._orderVouchersEnabled());
  private readonly _orderVouchersEnabled: WritableSignal<boolean> = signal(true);

  public orderExtendedDepositEnabled: Signal<boolean> = computed(() => this._orderExtendedDepositEnabled());
  private readonly _orderExtendedDepositEnabled: WritableSignal<boolean> = signal(false);

  // CEP Service Config
  public srmEnabled: Signal<boolean> = computed(() => this._srmEnabled());
  private readonly _srmEnabled: WritableSignal<boolean> = signal(true);

  public referenceTextEnabled: Signal<boolean> = computed(() => this._referenceTextEnabled());
  private readonly _referenceTextEnabled: WritableSignal<boolean> = signal(true);

  public requestedDeliveryDateEnabled: Signal<boolean> = computed(() => this._requestedDeliveryDateEnabled());
  private readonly _requestedDeliveryDateEnabled: WritableSignal<boolean> = signal(true);

  // Order History Delivery Filter - disabled until SAP logic is implemented
  public orderHistoryDeliveryFilterEnabled: Signal<boolean> = computed(() => this._orderHistoryDeliveryFilterEnabled());
  private readonly _orderHistoryDeliveryFilterEnabled: WritableSignal<boolean> = signal(false);

  public newCheckoutUiEnabled: Signal<boolean> = computed(() => this._newCheckoutUiEnabled());
  private readonly _newCheckoutUiEnabled: WritableSignal<boolean> = signal(true);

  // SRM 2.0 - AI ticket suggestion in summary step
  public ticketSuggestionEnabled: Signal<boolean> = computed(() => this._ticketSuggestionEnabled());
  private readonly _ticketSuggestionEnabled: WritableSignal<boolean> = signal(this.environmentService.type() !== 'prod');

  // Account Employee Administration
  public employeeAdminEnabled: Signal<boolean> = computed(() => this._employeeAdminEnabled());
  private readonly _employeeAdminEnabled: WritableSignal<boolean> = signal(this.environmentService.type() !== 'prod');

  // Documents (Planograms & Catalogs)
  public documentsEnabled: Signal<boolean> = computed(() => this._documentsEnabled());
  private readonly _documentsEnabled: WritableSignal<boolean> = signal(this.environmentService.type() !== 'prod');

  public shoppingListDownloadEnabled: Signal<boolean> = computed(() => this._shoppingListDownloadEnabled());
  private readonly _shoppingListDownloadEnabled: WritableSignal<boolean> = signal(true);

  public enablePublicApp(): void {
    this._publicAppEnabled.set(true);
  }

  public enableNewAppConfig(): void {
    this._newAppConfigEnabled.set(true);
  }
}
